<template>
  <Dialog
    v-model:visible="showDialog"
    :modal="true"
    :header="$t('5005.contactdetails.contactdetails')"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '900px' }"
    @after-hide="IsClear"
  >
    <b-container>
      <b-form @submit.prevent="isSubmit">
        <b-row>
          <b-col lg="5" md="6" sm="12" cols="12">
            <div class="field">
              <TextInput
                v-model="insert_contactdetails.ContactPerson"
                :label="$t('5005.contactdetails.contactperson')"
                name="Contact Person"
                id="Contact Person"
                :rules="{ required: true, alphabet: true }"
                :required-icon="true"
              />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="5" md="6" sm="12" cols="12">
            <div class="field">
              <TextInput
                v-model="insert_contactdetails.ContactDesignation"
                :label="$t('5005.contactdetails.designation')"
                name="Designation"
                id="Designation"
                :rules="{ alphabet: true }"
              />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="5" md="6" sm="12" cols="12">
            <div class="field">
              <TextInput
                placeholder=""
                v-model="insert_contactdetails.Phone"
                :label="$t('5005.contactdetails.phone')"
                name="Phone Number"
                id="Phone Number"
                :rules="{ required: true, Phonenumber: true }"
                :maxlength="10"
                :required-icon="true"
              />
            </div>
          </b-col>
          <b-col lg="5" md="6" sm="12" cols="12">
            <div class="field">
              <TextInput
                placeholder=""
                v-model="insert_contactdetails.LaneLine"
                :label="$t('5005.contactdetails.laneLinenumber')"
                name="LaneLine Number"
                id="LaneLine Number"
                :rules="{ required: false, landlinevalid: true }"
                :required-icon="false"
                :maxlength="10"
              />
            </div>
          </b-col>
        </b-row>
        <!-- <b-row>
                    <b-col lg="12" md="12" sm="12" cols="12">
                        <div class="field">
                            <TextInput placeholder="" v-model="insert_contactdetails.LaneLine" 
                                label="LaneLine Number" name="LaneLine Number" id='LaneLine Number'
                                :rules="{ required: true, numeric: true }" :maxlength="10" :required-icon="true" />
                        </div>
                    </b-col>
                </b-row> -->
        <b-row>
          <b-col lg="5" md="6" sm="12" cols="12">
            <div class="field">
              <TextInput
                v-model="insert_contactdetails.Email"
                :label="$t('5005.contactdetails.email')"
                :name="$t('5005.contactdetails.email')"
                :id="$t('5005.contactdetails.email')"
                :rules="{ required: true, email: true }"
                :required-icon="true"
                case="Lower"
              />
            </div>
          </b-col>
          <b-col lg="5" md="6" sm="12" cols="12">
            <div class="field">
              <TextInput
                v-model="insert_contactdetails.Fax"
                :label="$t('5005.contactdetails.fax')"
                name="FAX"
                id="FAX"
                :rules="{ required: false }"
                :required-icon="false"
              />
            </div>
          </b-col>
        </b-row>
        <!-- <b-row>
                    <b-col lg="6" md="6" sm="6" cols="6">
                        <div class="field">
                            <TextInput v-model="insert_contactdetails.Fax"  label="FAX" name="FAX" id='FAX'
                                :rules="{ required: true, }" />
                        </div>

                    </b-col>
                </b-row> -->
        <b-row>
          <b-col lg="5" md="6" sm="12" cols="12">
            <div class="field">
              <TextInput
                v-model="insert_contactdetails.Web"
                :label="$t('5005.contactdetails.website')"
                :name="$t('5005.contactdetails.website')"
                :id="$t('5005.contactdetails.website')"
                :rules="{ website: false }"
              />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <div class="d-flex flex-row-reverse my-3">
            <Footer @cancel="IsClear()" :label="btnlable" />
          </div>
        </b-row>
      </b-form>
    </b-container>
  </Dialog>
</template>
<script lang="ts">
import { defineComponent, ref, onMounted, provide, watch, reactive } from "vue";
import TextInput from "../../../../components/FormComponents/TextInput.vue";
import Footer from "../../../../components/FormComponents/Footer.vue";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import { useForm, validate } from "vee-validate";
import { useI18n } from "vue-i18n";
import { useToast } from "primevue/usetoast";

export default defineComponent({
  props: {
    showDialog: {
      type: Boolean,
      default: ref(false),
    },
    selectedItem: {
      type: Object,
      Default: () => {},
    },
    showButton: {
      type: Boolean,
      required: false,
    },
    creationtype: {
      type: Number,
    },

    indexval: {
      type: Number,
    },
    LaneMappingTemplateId: {
      type: Number,
      default: 0,
    },
    value: {},
  },

  components: {
    Footer,
    TextInput,
    // Footer,
  },
  setup(props, { emit }) {
    const router = useRouter();
    const route = useRoute();
    const { handleSubmit } = useForm();
    const toast = useToast();

    // watch(
    //   () => props.showDialog == true,
    //   () => {
    //     if (props.showDialog == true) {
    //       lanearray.value = []

    //     }
    //   }
    // )

    onMounted(() => {
      debugger;
    });
    const taskcreationpopup = ref(false);
    const { t } = useI18n();
    const label = ref(t("btn.save"));
    const showDialog = ref(true);
    const showTimerDelay = ref(false);

    let tasktype = ref();
    let statustype = ref();
    // let counsellingtype
    const model: any = ref(props.selectedItem);
    const IsClear = () => {
      emit("update:selectedItem", undefined);
      emit("close");
    };

    function IsCreate() {
      showDialog.value = true;
    }

    const IsEdit = async () => {
      debugger;

      try {
        let response: any;
        debugger;

        // response = await taskTemplateMasterService.getById(isForm.value.Id);
        // let data = response["result"][0]
        // .map(item => {
        //   return {
        //     ...item,
        //     laneIndex: props.indexval
        //   };
        // });;
        // data.LaneIndex = props.indexval;
        // data.LaneMappingTemplateId = props.LaneMappingTemplateId
        // // alert(JSON.stringify(data))
        // lanearray.value.push(data)
        // console.log(lanearray.value);

        // // const newArray = lanearray.value
        // emit('tasklanelist', lanearray.value)
      } catch (error) {
        // alert(error);
      }
    };

    const insert_contactdetails = reactive({
      Id: 0,
      ManufactureId: 0,
      ContactPerson: "",
      ContactDesignation: "",
      Phone: "",
      Email: "",
      Web: "",
      LaneLine: "",
      Fax: "",
      index: 0,
    });
    let btnlable = ref("Add Contact");

    onMounted(() => {
      if (model.value != null) {
        Object.assign(insert_contactdetails, model.value);

        btnlable.value = "Update Contact";
        // StatusVisible.value = true;
      } else {
        // btnlable.value = "Add Contact";
        // StatusVisible.value = true;
      }
      // input()
    });
    function input() {
      console.log("test");
      emit("update:modelValue", insert_contactdetails);
    }
    const isSubmit = handleSubmit(async (values) => {
      try {
        input(), IsClear();
        // let result: any;
        // let msg = "";
        // isForm.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        // isForm.value.ModifiedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        // isForm.value.HospitalId = localstoragedata.value.OrganizationId;
        // isForm.value.BranchId = localstoragedata.value.BranchId;
        // isForm.value.EntityId = 240;

        // debugger;
        // if (isForm.value.Id != 0) {
        //     result = await vaccinationMasterService.update(isForm.value);
        //     msg = result["ErrorInfo"].ErrorCode;
        //     if (result["result"] == "Already" && msg == null) {
        //         existname.value = "Vaccination Name"
        //         alreadyExistPop.value = true;
        //     } else if (msg == null) {
        //         updatePop.value = true;
        //     }
        // } else {
        //     result = await vaccinationMasterService.create(isForm.value);
        //     msg = result["ErrorInfo"].ErrorCode;
        //     debugger
        //     if (result["result"] == "Already" && msg == null) {
        //         existname.value = "Vaccination Name"
        //         alreadyExistPop.value = true;

        //     } else if (msg == null) {
        //         successPop.value = true;
        //     }
        // }
      } catch (error) {
        alert(error);
      }
    });
    return {
      btnlable,
      isSubmit,
      insert_contactdetails,
      input,
      IsClear,
      label,
      showDialog,
      IsCreate,
      showTimerDelay,
      tasktype,
      statustype,
    };
  },
});
</script>

<style lang="scss" scoped></style>
